/**
 * Auth Layout
 * Layout for authentication pages (login, register, etc.)
 */

import { Outlet } from 'react-router-dom';
import { BarChart3 } from 'lucide-react';

const AuthLayout = () => {
  return (
    <div className="min-h-screen flex">
      {/* Left Side - Branding */}
      <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-primary-600 to-primary-800 text-white p-12 flex-col justify-between">
        <div className="flex items-center gap-3">
          <BarChart3 size={40} />
          <h1 className="text-3xl font-bold">Marketing Analytics</h1>
        </div>

        <div className="space-y-6">
          <h2 className="text-4xl font-bold leading-tight">
            Transform Your Marketing Data Into Actionable Insights
          </h2>
          <p className="text-lg text-primary-100">
            Advanced analytics platform with real-time insights, funnel analysis, and AI-powered
            recommendations.
          </p>

          <div className="grid grid-cols-2 gap-4 mt-8">
            <div className="p-4 bg-white/10 rounded-lg backdrop-blur-sm">
              <div className="text-3xl font-bold">10K+</div>
              <div className="text-sm text-primary-100">Active Sessions</div>
            </div>
            <div className="p-4 bg-white/10 rounded-lg backdrop-blur-sm">
              <div className="text-3xl font-bold">99.9%</div>
              <div className="text-sm text-primary-100">Uptime</div>
            </div>
            <div className="p-4 bg-white/10 rounded-lg backdrop-blur-sm">
              <div className="text-3xl font-bold">500+</div>
              <div className="text-sm text-primary-100">Companies</div>
            </div>
            <div className="p-4 bg-white/10 rounded-lg backdrop-blur-sm">
              <div className="text-3xl font-bold">24/7</div>
              <div className="text-sm text-primary-100">Support</div>
            </div>
          </div>
        </div>

        <div className="text-sm text-primary-100">
          © 2024 Marketing Analytics Platform. All rights reserved.
        </div>
      </div>

      {/* Right Side - Auth Form */}
      <div className="flex-1 flex items-center justify-center p-8 bg-white dark:bg-secondary-900">
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
